


































































































































































import { Component, Mixins } from "vue-mixin-decorator";
import { Prop } from "vue-property-decorator";
import { ModeInfo } from "mode";
import urljoin from "url-join";
import { Rectangle } from "address";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import {
  CardDeckBig,
  CardMeta,
  CardObject,
  CardYamlInfo,
  InputCardInfo,
  OtherTextViewInfo
} from "@/@types/gameObject";
import { createPoint } from "@/app/core/utility/CoordinateUtility";
import CardComponent from "@/app/basic/card/CardComponent.vue";
import { StoreUseData } from "@/@types/store";
import CardChooserComponent, {
  CardCountInfo
} from "@/app/basic/card/builder/CardChooserComponent.vue";
import ThrowCharSelect from "@/app/basic/common/components/select/ThrowCharSelect.vue";
import ImagePickerComponent from "@/app/core/component/ImagePickerComponent.vue";
import GameObjectManager from "@/app/basic/GameObjectManager";
import TextFrame from "@/app/basic/card/builder/TextFrame.vue";
import CardDeckChooseBackImageComponent from "@/app/basic/card/builder/CardDeckChooseBackImageComponent.vue";
import ComponentVue from "@/app/core/window/ComponentVue";
import CardDeckCreateEntranceComponent from "@/app/basic/card/builder/CardDeckCreateEntranceComponent.vue";
import { createEmptyStoreUseData, getSrc } from "@/app/core/utility/Utility";
import CardDeckCreateCardComponent from "@/app/basic/card/builder/CardDeckCreateCardComponent.vue";
import SocketFacade from "@/app/core/api/app-server/SocketFacade";
import BaseInput from "@/app/core/component/BaseInput.vue";
import { loadYaml } from "@/app/core/utility/FileUtility";
import VueEvent from "@/app/core/decorator/VueEvent";
import TaskManager from "@/app/core/task/TaskManager";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import CardDeckFrameSettingComponent from "@/app/basic/card/builder/CardDeckFrameSettingComponent.vue";
import CardDeckChooserComponent from "@/app/basic/card/builder/CardDeckChooserComponent.vue";

const cardDeckYamlPath = "/static/conf/deck.yaml";

type DeckInfo = {
  cardDeckBig: StoreUseData<CardDeckBig>;
  cardMetaList: StoreUseData<CardMeta>[];
};

@Component({
  components: {
    CardDeckCreateEntranceComponent,
    CardDeckCreateCardComponent,
    CardDeckFrameSettingComponent,
    CardDeckChooseBackImageComponent,
    ImagePickerComponent,
    BaseInput,
    TextFrame,
    CardChooserComponent,
    CardDeckChooserComponent,
    CardComponent,
    CtrlButton,
    ThrowCharSelect
  }
})
export default class CardDeckBuilder extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: String, default: "" })
  private cardDeckId!: string;

  public static DEFAULT_CARD_FRAME_PARANOIA_REBOOTED: CardMeta = {
    width: 200,
    height: 300,
    radius: 0,
    padHorizontal: 0,
    padTop: 140,
    padBottom: 0,
    frontBackgroundColor: "#ffffff",
    backBackgroundColor: "#ffffff",
    fontColor: "#000000",
    nameHeight: 0,
    nameFontSize: 20,
    nameBackgroundColor: "rgba(0, 0, 0, 0)",
    textHeight: 0,
    textFontSize: 11,
    textPadding: 5,
    textBackgroundColor: "rgba(0, 0, 0, 0)",
    frontImage: "",
    backImage: "",
    name: "",
    text: ""
  };

  private ml: string = "card-deck-builder.message-list";

  private cardDeckBigList = GameObjectManager.instance.cardDeckBigList;
  private cardMetaList = GameObjectManager.instance.cardMetaList;
  private mediaList = GameObjectManager.instance.mediaList;

  private presetDeckList: DeckInfo[] = [];
  private dbDeckList: DeckInfo[] = [];
  private selectedDeckIdList: string[] = [];

  private newDeckName: string = "";
  private newDeckBackColor: string = "#ffffff";
  private newDeckBackImageId: string = "";
  private newDeckTag: string | null = null;

  private width: number = 200;
  private height: number = 300;
  private radius: number = 0;
  private padHorizontal: number = 0;
  private padTop: number = 0;
  private padBottom: number = 0;
  private frontBackgroundColor: string = "#ffffff";
  private fontColor: string = "#000000";
  private nameHeight: number = 30;
  private nameFontSize: number = 20;
  private nameBackgroundColor: string = "rgba(0, 0, 0, 0)";
  private textHeight: number = 60;
  private textFontSize: number = 11;
  private textPadding: number = 0;
  private textBackgroundColor: string = "rgba(0, 0, 0, 0)";

  private newCardList: StoreUseData<CardMeta>[] = [];

  private selectedCardList: CardCountInfo[] = [];
  private statusNum: number = 1;
  private subStatusNum: number = 1;

  private otherTextViewInfo: OtherTextViewInfo | null = null;

  private cardMetaCC = SocketFacade.instance.cardMetaCC();
  private cardDeckBigCC = SocketFacade.instance.cardDeckBigCC();
  private cardObjectCC = SocketFacade.instance.cardObjectCC();

  @VueEvent
  private async resistDeck() {
    // 大山札の登録
    const cardDeckBigId: string = (
      await this.cardDeckBigCC.addDirect([{ name: this.newDeckName }])
    )[0];

    const cardMetaList: CardMeta[] = this.selectedCardList
      .filter(ccInfo => ccInfo.count)
      .map(ccInfo => this.cardList.filter(c => c.id === ccInfo.id)[0].data!);
    const cardMetaIdList = await this.cardMetaCC.addDirect(
      cardMetaList,
      cardMetaList.map(() => ({
        owner: cardDeckBigId
      }))
    );

    window.console.log(JSON.stringify(cardMetaList, null, "  "));
    window.console.log(JSON.stringify(cardMetaIdList, null, "  "));

    const cardObjectList: CardObject[] = this.selectedCardList
      .filter(ccInfo => ccInfo.count)
      .map((ccInfo, idx) => {
        // const idx: number = this.cardList.findIndex(c => (c.id = ccInfo.id));
        return {
          cardMetaId: cardMetaIdList[idx],
          cardDeckBigId,
          cardDeckSmallId: null,
          isTurnOff: true,
          point: createPoint(0, 0),
          angle: 0
        };
      });
    window.console.log(JSON.stringify(cardObjectList, null, "  "));
    await this.cardObjectCC.addDirect(
      cardObjectList,
      cardObjectList.map((_k, v) => ({
        order: v
      }))
    );
    await this.close();
  }

  @VueEvent
  private hoverCard(
    card: StoreUseData<CardMeta>,
    isHover: boolean,
    rect: Rectangle
  ) {
    if (isHover) {
      const text = `${card.data!.name}\n${card.data!.text}`;
      this.otherTextViewInfo = {
        type: "card-meta",
        docId: card.id!,
        text,
        rect,
        isFix: true
      };
    } else {
      this.otherTextViewInfo = null;
    }
  }

  @VueEvent
  private get cardList(): StoreUseData<CardMeta>[] {
    const resultList: StoreUseData<CardMeta>[] = [];

    resultList.push(...this.newCardList);

    this.presetDeckList
      .concat(this.dbDeckList)
      .filter(
        deck =>
          this.selectedDeckIdList.findIndex(id => id === deck.cardDeckBig.id) >
          -1
      )
      .forEach(deck => {
        resultList.push(...deck.cardMetaList);
      });
    return resultList;
  }

  @LifeCycle
  private async created() {
    // DBデッキリストを参照
    this.cardDeckBigList.forEach(cardDeckBig => {
      const cardMetaList: StoreUseData<CardMeta>[] = this.cardMetaList.filter(
        cm => cm.owner === cardDeckBig.id
      );
      this.dbDeckList.push({ cardDeckBig, cardMetaList });
    });

    // プリセットデッキの読み込み
    (await loadYaml<CardYamlInfo[]>(cardDeckYamlPath)).forEach(
      (presetDeck: CardYamlInfo, deckIdx: number) => {
        const name = presetDeck.title;
        const id = `preset-deck-${name}-${deckIdx}`;
        const cardDeckBig = createEmptyStoreUseData(id, { name });
        const cardMetaList: StoreUseData<CardMeta>[] = presetDeck.cards.map(
          (c: InputCardInfo, cardIdx: number) => {
            const cardId = `preset-card-${deckIdx}-${cardIdx}`;
            const basePath = presetDeck.basePath || "";
            const cardMeta: CardMeta = {
              width: presetDeck.width,
              height: presetDeck.height,
              padHorizontal: presetDeck.padHorizontal || 0,
              padTop: presetDeck.padTop || 0,
              padBottom: presetDeck.padBottom || 0,
              radius: presetDeck.radius || 0,
              frontImage: c.imagePath
                ? `url(${getSrc(urljoin(basePath, c.imagePath))})`
                : "",
              frontBackgroundColor: c.backgroundColor || "#ffffff",
              backImage: presetDeck.back.imagePath
                ? `url(${getSrc(urljoin(basePath, presetDeck.back.imagePath))})`
                : "",
              backBackgroundColor: presetDeck.back.backgroundColor || "#ffffff",
              fontColor: c.fontColor || "#000000",
              name: c.name || "",
              nameHeight: presetDeck.nameHeight || 0,
              nameFontSize: presetDeck.nameFontSize || 20,
              nameBackgroundColor:
                presetDeck.nameBackgroundColor || "rgba(0, 0, 0, 0)",
              text: c.text || "",
              textHeight: presetDeck.textHeight || 0,
              textFontSize: presetDeck.textFontSize || 11,
              textPadding: presetDeck.textPadding || 0,
              textBackgroundColor:
                presetDeck.textBackgroundColor || "rgba(0, 0, 0, 0)"
            };
            if (!cardMeta.radius) cardMeta.radius = 0;
            return createEmptyStoreUseData(cardId, cardMeta);
          }
        );
        this.presetDeckList.push({ cardDeckBig, cardMetaList });
      }
    );
  }

  @VueEvent
  private async rollback(): Promise<void> {
    await this.close();
  }

  @VueEvent
  private async close(): Promise<void> {
    await TaskManager.instance.ignition<ModeInfo, never>({
      type: "mode-change",
      owner: "Quoridorn",
      value: {
        type: "view-card-deck",
        value: {
          flag: "off" as "off",
          cardDeckId: ""
        }
      }
    });
  }

  @VueEvent
  private otherTextHide() {
    this.otherTextViewInfo = null;
  }
}
